import { SharedService } from 'src/app/services/shared.service';
import { Component, OnInit } from '@angular/core';
import { Alert } from 'src/app/models/alert.model';
import { ToastService } from 'src/app/services/toast.service';

@Component({
    selector: 'app-alert',
    templateUrl: './alert.component.html',
    styles: [],
})
export class AlertComponent implements OnInit {
    constructor(public sharedService: SharedService, public toastService: ToastService) {}

    ngOnInit(): void {}

    addAlert(alert: Alert) {
        this.toastService.show(alert.message, { classname: this.getAlertClass(alert), delay: 10 });
    }

    getAlertClass(alert: Alert) {
        switch (alert.type) {
            case 'success':
                return 'message-success';
            case 'error':
                return 'message-error';
            case 'warning':
                return 'message-warning';
        }
    }
}
